import { fg } from '@atlassian/jira-feature-gating';
import { getNavigationResources } from '@atlassian/jira-router-resources-navigation/src/index.tsx';
import { resourceWithCondition2 } from '@atlassian/jira-router-resources-utils/src/utils/resource-with-condition/index.tsx';
import { getServicedeskPageContextResources } from '@atlassian/jira-router-resources-service-desk-common/src/index.tsx';
import { getConsentBannerUserPreferencesResource } from '@atlassian/jira-router-resources-cookie-consent/src/index.tsx';
import { workspaceResource } from '@atlassian/jira-servicedesk-insight-common-workspace-context/src/services/resources/index.tsx';
import { themePreferenceResource } from '@atlassian/jira-router-resources-theme-preference/src/controllers/resource-erai-1615-old/index.tsx';
import { rovoEntitlementResource } from '@atlassian/jira-router-resources-rovo-entitlement/src/services/index.tsx';
import { assetsNavigationSettingsResource } from '@atlassian/jira-router-resources-assets-admin-settings/src/index.tsx';

export function getCmdbResources() {
	return [...getNavigationResources(), ...getServicedeskPageContextResources(), workspaceResource];
}

export function getAssetsAppResources() {
	return [
		workspaceResource,
		themePreferenceResource,
		resourceWithCondition2(
			() => fg('aurum-assets-as-a-platform'),
			assetsNavigationSettingsResource,
		),
		rovoEntitlementResource,
		getConsentBannerUserPreferencesResource(),
	];
}
